import React, { Fragment } from 'react'
import './subSolutions.scss'
import { FaIndustry, FaUsers, FaPlug } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

export const SubMenuLink = ({ link, text }) => (
  <Fragment>
    <a href={link}>
      <p>{text}</p>
    </a>
  </Fragment>
)



export default function SubMenuSolutions() {
  const { t } = useTranslation()

  return (
    <div className="container-submenuSolutions">
      <div className="submenu-Solutions">
        <div className="porindustria">
          <div className="title-porIndustria">
            <h1><FaIndustry /> {t("navbar.solutions.sectors.title")}</h1> 
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ paddingRight: "2em" }}>
              <SubMenuLink link={"/retail"} text={t("navbar.solutions.sectors.retail_text")} />
              <SubMenuLink link={"/financial"} text={t("navbar.solutions.sectors.financial_text")} />
              <SubMenuLink link={"/publicSector"} text={t("navbar.solutions.sectors.public_sector_text")} />
              <SubMenuLink link="/industry" text={t("navbar.solutions.sectors.industry_text")} />
            </div>
            <div>
              <SubMenuLink link="/education" text={t("navbar.solutions.sectors.education_text")}/>
              <SubMenuLink link="/ecommerce"  text={t("navbar.solutions.sectors.ecommerce_text")} />
              <SubMenuLink link="/health" text={t("navbar.solutions.sectors.health_text")} />
              <SubMenuLink link={"/telecom"} text={t("navbar.solutions.sectors.telecom_text")} />
            </div>
          </div>
        </div>
        
        <div className="porindustria">
          <div className="title-porIndustria">
            <h1><FaIndustry /> {t("navbar.solutions.sectors.title_2")}</h1> 
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ paddingRight: "2em" }}>
              <SubMenuLink link={"/DataProtection"} text={t("navbar.solutions.sectors.database_text")} />
            </div>
            <div>
              <SubMenuLink link={"/FinancialsOperational"} text={t("navbar.solutions.sectors.financials_operational")} /> 
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
